import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MailCheck } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { authApi } from '@/api/endpoints';
import { Loader } from '@/components/common/Loader';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try { await authApi.requestReset(email); setSent(true); }
    catch { setSent(true); /* anti-enum: sempre sucesso */ }
    finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto mb-3 h-14 w-14 rounded-xl bg-primary flex items-center justify-center">
            <MailCheck className="h-7 w-7 text-primary-foreground" />
          </div>
          <CardTitle>{t('auth.forgot.title')}</CardTitle>
          <CardDescription>{t('auth.forgot.subtitle')}</CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-4">
              <p className="text-sm text-center">{t('auth.forgot.sent')}</p>
              <Link to="/login" className="block"><Button className="w-full" variant="outline">{t('common.back')}</Button></Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label>{t('auth.email')}</Label>
                <Input type="email" required autoFocus value={email} onChange={e => setEmail(e.target.value)} disabled={loading} />
              </div>
              <Button type="submit" className="w-full" disabled={loading}>
                {loading ? <Loader /> : t('auth.forgot.submit')}
              </Button>
              <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">{t('common.back')}</Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
